import { ConfigProvider } from 'shared/config/ConfigContext';
import fhhData from 'shared/seo/data/fhh.json';
import type { SeoPlace } from 'shared/seo/interfaces';
import { LinkTree } from 'shared/seo/LinkTree';
import { PopularCities } from 'shared/seo/PopularCities';
import { DestinationPage } from '@/components/DestinationPage';
import { countryLevel1Factory, vacationRentalSearchFactory } from '@/components/factory';
import { feConfig } from '@/config';
import { fhhCountries, fhhMapping } from '@/data';
import { verticals } from '@/data/verticals';
import type { CityPlace } from '@/interfaces/place';

export async function getStaticPaths() {
    const destinations = fhhCountries.map((place) => ({
        params: { countryLevel1: place.countryPath },
    }));

    return {
        paths: destinations,
        fallback: false,
    };
}

export async function getStaticProps(context) {
    const destination = fhhCountries.find((place) => place.countryPath === context.params.countryLevel1.toLowerCase());
    const popularCities = fhhMapping[destination.id] ?? [];

    return {
        props: {
            destination,
            popularCities,
            config: feConfig,
        },
    };
}

export interface Props {
    destination: CityPlace;
    popularCities: SeoPlace[];
    config: Record<string, string>;
}

const CountryLevel1 = ({ destination, popularCities, config }: Props) => {
    const factory = countryLevel1Factory(destination, vacationRentalSearchFactory());

    return (
        <ConfigProvider config={config}>
            <DestinationPage factory={factory} vertical={verticals.fhh} data={fhhData}>
                <PopularCities
                    destination={destination}
                    cities={popularCities}
                    cdnUrl={fhhData.cdnPath}
                    verticalUrl={fhhData.basePath}
                    lang={fhhData.lang}
                />
                <LinkTree
                    heading={fhhData.lang.linkTree.heading}
                    description={fhhData.lang.linkTree.description}
                    data={fhhData.linkTree}
                    url={fhhData.basePath}
                />
            </DestinationPage>
        </ConfigProvider>
    );
};

export default CountryLevel1;
